export const getBankAccountNumber = (accounts, currency) => {
  if (!Array.isArray(accounts)) return "";
  return accounts.find((account) => account.currency === currency)?.number;
};
